import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import Success from '../success/Success';
import ErrorBox from '../error-box/ErrorBox';
import RoundedButtonPrimary from '../button/rounded-button-primary/RoundedButtonPrimary';
import styles from './global-modal.module.less';
import { clearGlobalModal } from '../../global-message/global-message-actions';
import { Modal, ModalBlock } from '@sb1/ffe-modals-react';
import { useEffect, useRef } from 'react';

const GlobalModal = ({ dispatch, img }) => {
    const modalRef = useRef(null);
    const globalMessage = useSelector((state) => state.globalMessage);

    useEffect(() => {
        if (globalMessage.globalMessageOpen && modalRef.current) {
            modalRef.current.open();
        } else {
            modalRef.current.close();
        }
    }, [globalMessage]);

    const closeModal = () => {
        dispatch(clearGlobalModal());
    };

    const error = globalMessage.error;
    const message = error ? <ErrorBox error={error} /> : <Success success={globalMessage.success} img={img} />;

    return (
        <Modal ref={modalRef} aria-label="Viser melding" onClose={closeModal}>
            <ModalBlock>
                <div className={styles.content}>
                    {message}
                    <RoundedButtonPrimary onClick={closeModal} className={styles.button}>
                        Ok
                    </RoundedButtonPrimary>
                </div>
            </ModalBlock>
        </Modal>
    );
};

GlobalModal.propTypes = {
    dispatch: PropTypes.func.isRequired,
    img: PropTypes.string,
};

function mapStateToProps(state, props) {
    return {
        img: state.globalMessage.img,
        dispatch: props.dispatch,
    };
}

export default connect(mapStateToProps)(GlobalModal);
